import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="bg-charcoal py-24 px-6 md:px-12 relative overflow-hidden" data-id="element-105">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-amber/5 blur-[120px] rounded-full pointer-events-none" data-id="element-106" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-br from-amber/20 to-charcoal-light border border-amber/30 rounded-3xl p-8 md:p-16 text-center shadow-2xl shadow-amber/10" data-id="element-108">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber/20 text-amber mb-8" data-id="element-109">
            <Flame size={32} data-id="element-110" />
          </div>

          <h2 className="font-serif text-3xl md:text-5xl font-bold text-amber mb-8" data-id="element-111">
            El Protocolo de Humidificación Criolla
          </h2>

          <p className="font-sans text-lg md:text-xl text-cream/90 mb-8 leading-relaxed" data-id="element-112">
            Este no es un libro de dieta. Es un manual de ingeniería para el
            hogar.
          </p>

          <p className="font-sans text-lg md:text-xl text-cream/80 leading-relaxed" data-id="element-113">
            Aprendé la técnica del{' '}
            <span className="text-amber font-bold" data-id="element-114">"Rocío de Oro"</span> y el{' '}
            <span className="text-amber font-bold" data-id="element-115">"Choque Térmico"</span> para
            sellar los jugos de la carne al instante mientras el aire caliente
            crea una costra dorada nivel bodegón porteño.
          </p>
        </motion.div>
      </div>
    </section>;
}